/**
 * Buy-box telemetry listener — the cross-page attribution resume path the
 * minimum-viable buy-box spec always assumed and nobody wrote.
 *
 * `assets/buybox.js` dispatches `buybox:ready`, `buybox:select`, `buybox:add`
 * and `buybox:fail` into an empty room. F2 of
 * docs/research/boops-meta-lp-buybox-attribution-adversarial-review-2026-09-21.md:
 * nothing calls __cwCartAttributeWriter.resumeAcquisition(), so a session
 * whose FIRST page is the buy box writes no cw_* attributes at all and its
 * orders reach the warehouse unattributed. `resume()` below fixes that; it
 * runs once, unconditionally, on load.
 *
 * R-13 (2026-09-23,
 * docs/plans/boops-buybox-v3-simplification-plan-2026-09-22.md §0.1) retired
 * this asset's OTHER job. The LP telemetry plan (2026-09-21 §3 W3) had also
 * built a `checkout_entered` emitter here on top of `buybox:add` — F3/F4 of
 * the same review — but that copy carried the wrong, pre-V3 surface id
 * (`premium_anchor_v2_buy_box`), a plain `gtag` call with no retry, and an
 * `__cwObsvPurchaseFlow` bridge call that could never succeed (no
 * `intentId`/`routeMarker` on this path). Because `assets/buybox.js` already
 * announces the same entry as a `cw:checkout_entered` document event that
 * `snippets/cart-drawer-analytics.liquid` sends (beacon + ack + retry,
 * correct surface/arm/unit_id/checkout_path), this asset's copy was a live
 * DUPLICATE (Status L-2), not a second signal. `publish()`, `checkoutEntered()`
 * and the `buybox:add` listener that called them are deleted; nothing else in
 * `assets/buybox.js` or any snippet listens for this asset's own `buybox:add`
 * handler, so removing it drops no coverage.
 * `snippets/cart-drawer-analytics.liquid` is the single `checkout_entered`
 * owner now, per R-13.
 *
 * This asset never touches money: it does not read, write or clear the cart,
 * and `resume()` is wrapped so a telemetry failure can never block a purchase.
 */
(function (win) {
  "use strict";

  function resume() {
    try {
      var writer = win.__cwCartAttributeWriter;
      if (writer && typeof writer.resumeAcquisition === "function") writer.resumeAcquisition();
    } catch (e) { /* attribution must never block the buy box */ }
  }

  resume();
}(window));
